// @module Eureka.MaxaTrendingProducts.TrendingProcuts
define('Eureka.MaxaTrendingProducts.AboutUs.View'
    , [
        'PageType.Base.View',
        'eureka_maxatrendingproducts_aboutus.tpl'
    ]
    , function (
        PageTypeBaseView,
        eureka_maxatrendingproducts_aboutus_tpl
    ) {
        'use strict';

        // @class Eureka.MaxaTrendingProducts.TrendingProcuts.View @extends Backbone.View
        return PageTypeBaseView.PageTypeBaseView.extend({

            template: eureka_maxatrendingproducts_aboutus_tpl

            , initialize: function (options) {

                let dataCompany = "ate",
                    dataQuestionType = "nps",
                    dataTimeUnit = "day",
                    dataTimeValue = 30,
                    dataFilters = [{ "column": "market_c", "operator": "in", "value": ["Maxa Customers"] }],
                    query = `questionType=${dataQuestionType}&timeUnit=${dataTimeUnit}&timeValue=${dataTimeValue}`,
                    self = this;

                let url = `https://${dataCompany}.asknice.ly/api/v1/nps/data.json?${query}`;

                var xhr = new XMLHttpRequest();
                if ("withCredentials" in xhr) {
                    xhr.open("GET", url, true);
                } else if (typeof XDomainRequest !== "undefined") {
                    xhr = new XDomainRequest();
                    xhr.open("GET", url);
                } else {
                    return callback(0, { success: false, msg: "CORS not supported" });
                }

                xhr.onload = function () {
                    try {
                        var response = JSON.parse(xhr.responseText);
                        console.log("Fetched Data:", response);
                        self.npsSCore = response.success ? response.data.nps : "N/A";
                        self.render()
                        //callback(0, response);
                    } catch (error) {
                        console.error("Error parsing JSON:", error);
                        callback(0, { success: false, msg: "Invalid JSON response" });
                    }
                };

                xhr.onerror = function () {
                    callback(0, { success: false, msg: "Request failed" });
                };

                xhr.send();


            }

            , beforeShowContent: function beforeShowContent() {
                this.getBreadcrumbPages = function () {
                    return [{
                        text: 'About Us',
                        href: ''
                    }];
                };

                return jQuery.Deferred().resolve()


            },

            createTestimonialHTML: function createTestimonialHTML(testimonial) {
                function formatComment(comment) {
                    return comment.charAt(0).toUpperCase() + comment.slice(1);
                }
                console.log("In Testimonial", testimonial)
                let initials = testimonial.name.toUpperCase().split(" ").map(word => word[0]).join(""),
                    formattedComment = formatComment(testimonial.comment),
                    date = new Date(testimonial.time * 1000).toLocaleDateString(),
                    avatar = testimonial.avatar ? `<img src="${testimonial.avatar}" alt="${testimonial.name}" />` : `<span>${initials}</span>`;

                return `
                            <div class="testimonial">
                                <div class="testimonial-header">
                                    ${avatar}
                                    <div>
                                        <p class="testimonial-name">${testimonial.name}</p>
                                        ${testimonial.company ? `<p class="testimonial-company">${testimonial.company}</p>` : ''}
                                        <p class="testimonial-date">${date}</p>
                                    </div>
                                </div>
                                <p class="testimonial-comment">${formattedComment}</p>
                            </div>
                        `;
            }

            //@method getContext @return Eureka.MaxaTrendingProducts.TrendingProcuts.View.Context
            , getContext: function getContext() {
                if (window.location.hash) {
                    console.log("getContext", window.location.hash);
                    try {
                        setTimeout(function () {
                            switch (window.location.hash) {
                                case "#ourJourney":
                                    document.getElementById("ourJourney").scrollIntoView({ behavior: "smooth" });
                                    return;
                                case "#ourValues":
                                    document.getElementById("ourValues").scrollIntoView({ behavior: "smooth" });
                                    return;
                                case "#testimonial":
                                    document.getElementById("maxaTestimonials").scrollIntoView({ behavior: "smooth" });
                                    return;
                            }
                        }, 800)

                    } catch (e) {
                        console.log("getContext in scroll", e);
                    }

                }




                return {
                    npsSCore: this.npsSCore
                };
            }
        });
    });
